// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmploymentStatus-module__wrapper___8AG0b {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  /* 見出しが.selectionWrapperの外にあるため、他ステップ(40+32)と同じ72pxで揃える */\n  padding-top: 72px;\n}\n\n.EmploymentStatus-module__selectionWrapper___vGO8n {\n  display: flex;\n  flex-direction: row;\n  max-width: 400px;\n  grid-gap: 16px;\n  grid-gap: 16px;\n  gap: 16px;\n  justify-content: center;\n  padding: 32px 16px 16px 16px;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "EmploymentStatus-module__wrapper___8AG0b",
	"selectionWrapper": "EmploymentStatus-module__selectionWrapper___vGO8n"
};
export default ___CSS_LOADER_EXPORT___;
